import { Link, useNavigate } from 'react-router-dom';
import FlashIcon from '../../assets/icons/flash.svg'
import AlarmIcon from '../../assets/icons/alarm.svg'
import DollarIcon from '../../assets/icons/dollar.svg'
import DownIcon from '../../assets/icons/arrow_down.svg'
import UKIcon from '../../assets/icons/uk.svg'
import FRIcon from '../../assets/icons/fr.svg'
import ConnectIcon from '../../assets/icons/folder.svg'
import { useState } from 'react';
import { Button } from '@material-tailwind/react';
import MenuIcon from '../../assets/icons/menu.svg'
import AvatarIcon from '../../assets/icons/avatar.svg'
import { reducedAddress } from '../../utils/utils';
import { useWallet } from '../../context/WalletContext';

const Header = () => {
    const navigate = useNavigate();
    const { wallet, isConnected, connectDemo, connectMetamask, disconnect, demoWallets } = useWallet();
    const [curencyShow, setCurencyShow] = useState(false)
    const [langShow, setLangShow] = useState(false)
    const [walletShow, setWalletShow] = useState(false)
    const [menuShow, setMenuShow] = useState(false)
    const [langIdx, setLangIdx] = useState(0);
    const [currencyIdx, setCurrencyIdx] = useState(0);
    const currencyList = [{ name: "USD" }, { name: "EUR" }];
    const lanList = [
        { name: "UK", img: UKIcon },
        { name: "FR", img: FRIcon },
    ];

    const navs = [
        { name: "Home", path: "/" },
        { name: "Claim", path: "/claim" },
        { name: "Account", path: "/account" },
    ];

    const closeMenus = () => {
        setWalletShow(false);
        setLangShow(false);
        setCurencyShow(false);
        setMenuShow(false);
    };

    const WalletMenu = ({ align = 'right-0' }) => (
        <>
            <div className="fixed top-0 left-0 w-screen h-screen bg-transparent z-10" onClick={closeMenus} />
            <div className={`bg-[#1B1B1B] flex flex-col rounded-lg absolute z-50 top-[48px] ${align} min-w-[220px] py-2 border border-[#2C2C2C]`}>
                <button
                    className="text-left text-white px-4 py-3 hover:bg-[#2C2C2C]"
                    onClick={async () => {
                        try {
                            await connectMetamask();
                            closeMenus();
                            navigate('/account');
                        } catch (err) {
                            alert(err.message);
                        }
                    }}
                >
                    MetaMask
                </button>
                {demoWallets.map((item) => (
                    <button
                        key={item.address}
                        className="text-left text-white px-4 py-3 hover:bg-[#2C2C2C]"
                        onClick={() => {
                            connectDemo(item.address);
                            closeMenus();
                            navigate('/account');
                        }}
                    >
                        {item.label}
                    </button>
                ))}
                {isConnected && (
                    <button
                        className="text-left text-[#FBBF04] px-4 py-3 hover:bg-[#2C2C2C]"
                        onClick={() => {
                            disconnect();
                            closeMenus();
                        }}
                    >
                        Disconnect
                    </button>
                )}
            </div>
        </>
    );

    return (
        <div className='sticky top-0 z-50 w-full bg-bg shadow pt-[env(safe-area-inset-top)]'>
            <div className='flex flex-row py-3 sm:py-[20px] px-4 sm:px-[20px] lg:px-[150px] items-center justify-between gap-2'>
                <Link to="/" className='block min-w-0' onClick={closeMenus}>
                    <div className="flex flex-row items-center gap-1">
                        <img src={FlashIcon} alt="flash" className='h-[32px] sm:h-[39px]' />
                        <p className="text-white text-[16px] sm:text-[19px] truncate">Flash Dead</p>
                    </div>
                </Link>

                <div className='flex flex-row gap-2 sm:gap-4 items-center shrink-0'>
                    <Button className='hidden sm:flex border border-stroke rounded-full h-[40px] w-[40px] p-3 cursor-pointer justify-center items-center'>
                        <img src={AlarmIcon} alt='alarm' />
                    </Button>

                    <div className="relative hidden md:flex">
                        <div
                            onClick={() => { setLangShow(!langShow); setCurencyShow(false); setWalletShow(false); }}
                            className="border border-iconBg rounded-[30px] py-[5px] px-[18px] min-w-[64px] h-[40px] flex flex-row gap-[8px] items-center cursor-pointer justify-center"
                        >
                            <img src={lanList[langIdx].img} alt="icon" className="w-[20px] h-[20px]" />
                            <p className="flex text-white text-[14px]">{lanList[langIdx].name}</p>
                            <img src={DownIcon} className={`${langShow && 'rotate-180'} w-[11px] h-[7px]`} alt="icon" />
                        </div>
                        {langShow && (
                            <>
                                <div className="fixed top-0 left-0 w-screen h-screen bg-transparent z-10" onClick={() => setLangShow(false)} />
                                <div className="bg-[#1B1B1B] flex flex-col rounded-lg absolute z-50 top-[40px] left-1 pb-2">
                                    {lanList.map((item, index) => (
                                        index !== langIdx &&
                                        <button
                                            key={index}
                                            className="flex flex-row py-[6px] px-[15px] w-[80px] border-b border-white items-center gap-[10px]"
                                            onClick={() => { setLangShow(false); setLangIdx(index) }}
                                        >
                                            <img src={item.img} alt="ico" className="w-[20px] h-[20px] rounded-[16px]" />
                                            <p className="text-white text-[14px]">{item.name}</p>
                                        </button>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>

                    <div className="relative hidden md:flex">
                        <div
                            onClick={() => { setCurencyShow(!curencyShow); setLangShow(false); setWalletShow(false); }}
                            className="border border-iconBg rounded-[30px] py-[5px] px-[18px] min-w-[64px] h-[40px] flex flex-row gap-[8px] items-center cursor-pointer justify-center"
                        >
                            <img src={DollarIcon} alt="icon" className="w-[20px] h-[20px]" />
                            <p className="flex text-white text-[14px]">{currencyList[currencyIdx].name}</p>
                            <img src={DownIcon} className={`${curencyShow && 'rotate-180'} w-[11px] h-[7px]`} alt="icon" />
                        </div>
                        {curencyShow && (
                            <>
                                <div className="fixed top-0 left-0 w-screen h-screen bg-transparent z-10" onClick={() => setCurencyShow(false)} />
                                <div className="bg-[#1B1B1B] flex flex-col rounded-lg absolute z-50 top-[40px] left-1 pb-2">
                                    {currencyList.map((item, index) => (
                                        index !== currencyIdx &&
                                        <button
                                            key={index}
                                            className="flex flex-row py-[6px] px-[15px] w-[80px] border-b border-white items-center gap-[10px]"
                                            onClick={() => { setCurencyShow(false); setCurrencyIdx(index) }}
                                        >
                                            <img src={DollarIcon} alt="ico" className="w-[20px] h-[20px]" />
                                            <p className="text-white text-[14px]">{item.name}</p>
                                        </button>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>

                    <div className="relative">
                        <Button
                            className='flex min-h-[40px] py-[8px] px-[12px] sm:px-[15px] items-center justify-center cursor-pointer gap-2 rounded-[30px] bg-yellow1 shadow-md'
                            onClick={() => { setWalletShow(!walletShow); setLangShow(false); setCurencyShow(false); setMenuShow(false); }}
                        >
                            <img src={ConnectIcon} alt='ico' className="w-4 h-4" />
                            <p className='text-black text-[12px] sm:text-[14px] whitespace-nowrap'>
                                {isConnected ? reducedAddress(wallet) : 'Connect'}
                            </p>
                        </Button>
                        {walletShow && <WalletMenu />}
                    </div>

                    {isConnected && (
                        <img src={AvatarIcon} alt='ico' className="hidden sm:block w-10 h-10" />
                    )}

                    <div className="relative md:hidden">
                        <Button
                            className='flex items-center justify-center min-w-[40px] min-h-[40px] p-2 bg-transparent'
                            onClick={() => { setMenuShow(!menuShow); setWalletShow(false); }}
                        >
                            <img src={MenuIcon} alt='menu' />
                        </Button>
                        {menuShow && (
                            <>
                                <div className="fixed top-0 left-0 w-screen h-screen bg-black/40 z-10" onClick={closeMenus} />
                                <div className="bg-[#1B1B1B] flex flex-col rounded-lg absolute z-50 top-[48px] right-0 min-w-[180px] py-2 border border-[#2C2C2C]">
                                    {navs.map((nav) => (
                                        <Link
                                            key={nav.path}
                                            to={nav.path}
                                            className="text-white px-4 py-3 hover:bg-[#2C2C2C]"
                                            onClick={closeMenus}
                                        >
                                            {nav.name}
                                        </Link>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
